import { ChevronDown, ChevronUp } from "lucide-react";

interface ErrorHeaderProps {
  message?: string;
  isExpanded: boolean;
  setIsExpanded: () => void;
}

export function ErrorHeader({
  message = "An error occurred",
  isExpanded,
  setIsExpanded,
}: ErrorHeaderProps) {
  return (
    <div className="flex items-start gap-1 w-full bg-secondary-300 p-2 text-secondary-n-50">
      <div className="size-4 flex flex-col items-center justify-center">
        <img
          src="/icons/ai-chat-status/failed.svg"
          className="size-4 shrink-0"
        />
      </div>
      <div
        onClick={setIsExpanded}
        className="cursor-pointer flex flex-1 justify-between items-start"
      >
        <div className="overflow-x-auto whitespace-pre-wrap break-words text-secondary-n-50 text-2xs">
          {message}
        </div>
        {isExpanded ? (
          <ChevronUp className="h-4 w-4 text-secondary-n-500" />
        ) : (
          <ChevronDown className="h-4 w-4 text-secondary-n-500" />
        )}
      </div>
    </div>
  );
}

export default ErrorHeader;
